<template>

</template>

<script>
import {useUserStore} from "@/console-new/stores";
import {isNative} from "@/shared/helpers/webapp";

export default {
	setup() {
		const userStore = useUserStore();
		return {userStore};
	},
	name: "ToDo",
	methods: {
		sendToAppropriateSection() {
			if(this.userStore.currBusiness) {
				if((this.userStore.currBusiness.plan_plugin_order_pay || this.userStore.currBusiness.plan_plugin_counter) && this.userStore.checkAnyOrderAllowed) {
					this.$router.push("/ops/orders");
				}
				else {
					if(this.userStore.currPermissions.includes("menu")) {
						this.$router.push("/config/menu");
					}
					else if(this.userStore.currPermissions.includes('admin')) {
						this.$router.push('/config/settings/general')
					}
					else if(this.userStore.currPermissions.includes('analytics')) {
						this.$router.push('/analytics')
					}
					else {
						this.$router.push('/lost')
					}
				}

			} else {
				if(this.userStore.noBusinesses) {
					this.$router.push('/lost')
				} else {
					//Waiting businesses to load...
				}
			}
		}
	},
	mounted() {
		this.sendToAppropriateSection();
	},
	watch: {
		"userStore.currBusiness": {
			handler: function(newPerm, oldPerm) {
				if(newPerm && (!oldPerm || newPerm !== oldPerm)) {
					this.sendToAppropriateSection();
				}
			},
		},
	},
}
</script>

<style scoped>

</style>